// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3rmRR","list":"BalanceDue_list__1X3Kx","listRow":"BalanceDue_listRow__1C9Qb","total":"BalanceDue_total__2RxSU"};